// questions page
//Varun: Will change the name after the prototype is ready.
angular.module('jv.video.interviewee.question.controller',[])
.controller('IntervieweeQuestionCtrl',['$scope', '$rootScope', 'videoService', '$location', '$routeParams', 'formResponseIdService', 'dataService', 'browserDetails', '$window', '$jobviteUrls', '$timeout', '$route','$log',
function ($scope, $rootScope, videoService, $location, $routeParams, formResponseIdService, dataService, browserDetails, $window, $jobviteUrls, $timeout, $route,$log) {
    // differentiates between the actual interview or a practice interview.
    $scope.interviewType = $routeParams.type;
    $scope.showOnUnloadMessage = false;
    $scope.showControls = false;
    $scope.hideTestButton = false;
    $scope.flashStatus = 'progress';
    $scope.cameraStatus = 'progress';
    $scope.micStatus = 'progress';
    $scope.adobeStatus = 'progress';
    $scope.archiveId = '';
    $scope.archiveName = '';
    $scope.vonageSessionId = '';
    $scope.vonageConnection = 'progress';
    $scope.vonageCamera = 'progress';
    $scope.vonageMicrophone = 'progress';
    $scope.vonageBrowserSupport = 'progress';
    $scope.vonageMicrophoneDeprecated = false;
    $scope.vonageTestStatus = 'progress';
    $scope.videoPreviewLoader = true;
    $scope.instructionStep1 = true;
    $scope.instructionStep2 = false;
    $scope.instructionStep3 = false;
    // Browser specific camera and audio access code.
    $scope.userMediaSupported = null;
    $scope.browserCameraAccess = null;
    $scope.beginloading=false;
    $scope.stoploading=false;
    $scope.vonageSessionLoading = false;
    $scope.isMobileDevice = /Mobi/i.test(window.navigator.userAgent);
    $scope.isIOS = /iPad|iPhone|iPod/.test(navigator.platform) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1) && !window.MSStream;

    //Method to call vonage system test
    $scope.createVonageSessionSystemTest = function() {
        if(!$scope.checknetworkConnectivityInterval) {
            $scope.checknetworkConnectivityInterval = setInterval(function(){
                if(!dataService.checkNetwrokConnection()){
                    $scope.vonageConnection = 'failed';
                }
            },10000);
        }
        // Added condition to show unsupported browser for IE/Edge browser
        // Added condition for mobile browsers
        // Updated condition for vonage testing - will remove once mobile testing is done on QA
        var userAgent = window.navigator.userAgent;
        if (userAgent.indexOf('MSIE ') > 0 || userAgent.indexOf('Trident/') > 0 || userAgent.indexOf('Edg/') > 0) {
            setFailedConnectionFlags({browserSupport: 'failed'});
            dataService.setSystemTestStatus('pending');
        } else {
            videoService.getVonageSessionId({}, function (result) {
                if (angular.isDefined(result) && angular.isDefined(result.vonageSessionId) && angular.isDefined(result.vonageSessionToken)) {
                    $scope.getVonageSystemTestStatus(result);
                }
            });
        }
     };

     $scope.setVonageConfigs = function() {
        $scope.vonageFlashStatusLoaded = true;
        $scope.showControls = true;
        var vonageSystemTestStatus = dataService.getSystemTestStatus();
        if (vonageSystemTestStatus === 'initated' || dataService.getSessionData('testConnectivityStarted') ||
        ($routeParams.state !== 'Setup' && vonageSystemTestStatus === 'pending')) {
            $scope.createVonageSessionSystemTest();
        }
    };


    //If vonageRecording variable is not set and session storage is not having vonageRecording
    //value, call backend to see whether vonage recording is enabled or not
    // && !$window.sessionStorage.getItem('isVonage')
    $scope.vonageRecording = dataService.getSessionData($routeParams.interviewId);
    $log.info('Vonage vonageRecording status for interviewId {0} - vonage enabled status is: {1}'.format($routeParams.interviewId, $scope.vonageRecording));
    if ($scope.vonageRecording == null) {
        var formResponseId = null;
        if ($scope.interviewType === 'recordInterview') {
            formResponseId = $routeParams.interviewId;
        }
        if ($scope.interviewType === 'practiceInterview') {
            formResponseId = dataService.getActualId() ? dataService.getActualId() : $routeParams.actualId;
            if (!formResponseId) {
                formResponseId = dataService.getSessionData($routeParams.interviewId+'-actualId');
                $routeParams.actualId = formResponseId;
                dataService.setActualId($routeParams.actualId);
            } else {
                dataService.setSessionData($routeParams.interviewId+'-actualId', formResponseId);
            }
        }
        videoService.isVonageEnabled({
            'formResponseId': formResponseId
        }, function (result) {
            if (angular.isDefined(result)) {
                $scope.vonageRecording = result.isVonage;
                dataService.setSessionData($routeParams.interviewId, result.isVonage);
                $scope.setVonageConfigs();
            }
        });
    } else {
        $scope.vonageRecording = $scope.vonageRecording === 'true';
    }

    if ($scope.vonageRecording) {
        $scope.setVonageConfigs();
    }

    if ($scope.interviewType === 'recordInterview' && dataService.getSessionData('isActualInterviewStarted')) {
        $rootScope.$broadcast('initPublisher',true);
        $scope.videoPreviewLoader = false;
        dataService.removeSessionData('isActualInterviewStarted');
    }
    function detectUserMedia(){
        // check the camera test only when its a test page.
        if(dataService.getSystemTest()){
            // navigator.getUserMedia = navigator.getUserMedia ||
            // navigator.webkitGetUserMedia ||
            // navigator.mozGetUserMedia ||
            // navigator.msGetUserMedia;
            if (navigator.mediaDevices.getUserMedia) {
                $scope.userMediaSupported = true;
                var success = function(stream){
                    $scope.browserCameraAccess = 'passed';
                    $scope.$digest();
                };
                var failure = function(err){
                    // temporary hack for FF on windows.
                    if(err.name === 'NotReadableError'){
                        $scope.browserCameraAccess = 'passed';
                        $scope.$digest();
                    }
                    if(err.name === 'PermissionDeniedError' || err === 'PERMISSION_DENIED'){
                        $scope.browserCameraAccess = 'failed';
                        $scope.$digest();
                    }
                };

                if($scope.browserCameraAccess !== 'passed'){
                    $scope.browserCameraAccess = 'progress';
                    // navigator.getUserMedia({audio: true, video: true}, success, failure);
                    navigator.mediaDevices.getUserMedia({audio: true, video:{facingMode: 'user'}})
                            .then(success)
                            .catch(failure);
                }
            }else{
                $scope.userMediaSupported = false;
            }
        }
    }

    /**
     * @method moveToVonageSystemTest
     * @description Validates if the user has already successfully completed the system test
     * based on the flag, proceeds to practice or actual interview
     */
    $scope.moveToVonageSystemTest = function() {
        var userAgent = window.navigator.userAgent;
        if (userAgent.indexOf('MSIE ') > 0 || userAgent.indexOf('Trident/') > 0 || userAgent.indexOf('Edg/') > 0){
            dataService.setSystemTestStatus('initated');
            $location.path('/Interview/' + $routeParams.type + '/' + $scope.interviewId);
        }else{
            videoService.validateDevices().then(function(devices){
                if(!(devices.includes('audioInput') &&  devices.includes('videoInput')) || dataService.getSystemTestStatus() === 'pending'){
                    dataService.setSystemTestStatus('initated');
                } else {
                    $scope.question = angular.copy($scope.questionCopy);
                    dataService.setSystemTest(false);
                }
                $location.path('/Interview/' + $routeParams.type + '/' + $scope.interviewId);
            });
        }
    };

     /**
     * @method moveToVonageInterview
     * @description Validates if the devices are still available else initates the system test again
     */
    $scope.moveToVonageInterview = function() {
        videoService.validateDevices().then(function(devices){
            if(devices.includes('audioInput') &&  devices.includes('videoInput')) {
                $scope.moveToInterview();
            } else {
                $scope.vonageConnection = 'progress';
                $scope.vonageCamera = 'progress';
                $scope.vonageMicrophone = 'progress';
                $scope.vonageBrowserSupport = 'progress';
                $scope.vonageTestStatus = 'progress';
                $scope.createVonageSessionSystemTest();
            }
        });
    };
    
    $scope.moveToInterview = function() {
        clearInterval($scope.checknetworkConnectivityInterval);
        $scope.question = angular.copy($scope.questionCopy);
        $scope.videoStatus = 'prepareTime';
        $scope.systemTest = false;
        dataService.setSystemTest(false);

        // remember that the system test was completed so that it can be skipped for the rest of this browser session
        !$scope.vonageRecording && dataService.setSessionData('completedSystemTest',true);
        $scope.interviewType = $routeParams.type;
        var newPath = '/Interview/' + $scope.interviewType + '/' + $scope.interviewId;
        $location.path(newPath);
    };

    /**
     * @method audioMeter
     * @description Starts the volume meter based on browser
     */
    function audioMeter(stream) {
        var audioContext = new AudioContext();
        var analyser = audioContext.createAnalyser();
        var microphone = audioContext.createMediaStreamSource(stream);
        var javascriptNode = audioContext.createScriptProcessor(2048, 1, 1);

        analyser.smoothingTimeConstant = 0.8;
        analyser.fftSize = 1024;

        microphone.connect(analyser);
        analyser.connect(javascriptNode);
        javascriptNode.connect(audioContext.destination);

        var canvasContext = $('#canvas')[0].getContext('2d');

        javascriptNode.onaudioprocess = function () {
            var array = new Uint8Array(analyser.frequencyBinCount);
            analyser.getByteFrequencyData(array);
            var values = 0;

            var length = array.length;
            for (var i = 0; i < length; i++) {
                values += (array[i]);
            }

            var average = values / length;

            canvasContext.clearRect(0, 0, 66, 20);
            canvasContext.fillStyle = '#38B24A';
            canvasContext.fillRect(0, 0, 0 + (average - 20), 20);
        };
    }

    /**
     * @method startVolumeLevelMeter
     * @description Starts the volume meter
     */
    function startVolumeLevelMeter() {
        navigator.getUserMedia = navigator.getUserMedia ||
            navigator.webkitGetUserMedia ||
            navigator.mozGetUserMedia ||
            navigator.msGetUserMedia;
        if (navigator.getUserMedia) {
            navigator.getUserMedia(
                {audio: true, video: true},
                audioMeter,
                function (error) {
                    $log.error("Vonage System Test status for startVolumeLevelMeter - {0}".format(error));
                });
        } else if(navigator.mediaDevices.getUserMedia) {
            navigator.mediaDevices.getUserMedia({audio: true})
            .then(audioMeter)
            .catch(function (error) {
                $log.error("Vonage System Test status for startVolumeLevelMeter - {0}".format(error));
            });
        }
    }

    /**
     * @method setFailedConnectionFlags
     * @description If the network is failed, set all the falgs to in progress and 
     * checks for browser IE and updates status
     */
    function setFailedConnectionFlags(params){
        $scope.vonageConnection = params && params.browserSupport ? 'passed' : 'failed';
        $scope.vonageMicrophone = 'progress';
        $scope.vonageCamera = 'progress';
        $scope.vonageBrowserSupport = params && params.browserSupport ? 'failed' : 'progress';
        $scope.vonageTestStatus = 'failed';
    }

     /**
     * @method validateSystemCheckStatus
     * @description If the network is failed, set all the falgs accordingly
     */
    function validateSystemCheckStatus() {
        if(!dataService.checkNetwrokConnection()){
            setFailedConnectionFlags();
        } else {
            $scope.vonageMicrophone = $scope.vonageMicrophone === 'failed' ? 'failed' : 'passed';
            $scope.vonageCamera = $scope.vonageCamera === 'failed' ? 'failed' : 'passed';
            $scope.vonageBrowserSupport = $scope.vonageBrowserSupport === 'failed' ? 'failed' : 'passed';
            $scope.vonageTestStatus = $scope.vonageTestStatus === 'failed' ? 'failed' : 'passed';
            $scope.vonageConnection = $scope.vonageConnection === 'failed' ? 'failed' : 'passed';
        }
        if ($scope.vonageCamera === 'passed') {
            $rootScope.$broadcast('initPublisher',true);
            $scope.videoPreviewLoader = false;
        }
        !$scope.$$phase && $scope.$digest();
    }

     /**
     * @method vonageConnection
     * @description Watches for the network connection and sets the flags accordingly
     */
    $scope.$watch('vonageConnection', function(newValue, oldValue) {
        if(newValue === 'failed') {
            setFailedConnectionFlags();
            !$scope.$$phase && $scope.$digest();
        }
    });

    /**
     * @method getVonageSystemTestStatus
     * @description Starts session for doing the system test
     * @param OTSessionData Session data
     */
    $scope.getVonageSystemTestStatus = function (OTSessionData) {
        var ErrorNames = window.OpenTokNetworkConnectivity.ErrorNames;
        var NetworkTest = window.OpenTokNetworkConnectivity.default;
        OT.getDevices(function(err, devices) {
            var videoSource = devices.find(function(device){
                return device.kind === 'videoInput';
           });
        var otNetworkTest = new NetworkTest(window.OT, {
            apiKey: window.atob(OTSessionData.encVonageKey),
            sessionId: OTSessionData.vonageSessionId,
            token: OTSessionData.vonageSessionToken
        }, {videoSource: videoSource.deviceId});
        dataService.setSessionData('testConnectivityStarted',true);
        $log.info('Vonage System Test status for vonageSessionId {0} and interviewId {1} - OpenTok system test session connected for interview'.format(OTSessionData.vonageSessionId,$scope.interviewId));
            otNetworkTest.testConnectivity().then(function (results) {
                $log.info('Vonage System Test status for vonageSessionId {0} and interviewId {1} - OpenTok connectivity test results {2}'.format(OTSessionData.vonageSessionId,$scope.interviewId,convertJSONToString(results)));
                 if (!results.success) {
                     angular.forEach(results.failedTests, function (result) {
                         switch (result.error.name) {
                             case ErrorNames.UNSUPPORTED_BROWSER:
                                 $scope.vonageBrowserSupport = 'failed';
                                 break;
                             case ErrorNames.MEDIA_DEVICE_ERROR:
                             case ErrorNames.FAILED_TO_CREATE_LOCAL_PUBLISHER:
                                 $scope.vonageMicrophone = 'failed';
                                 $scope.vonageCamera = 'failed';
                                 break;
                             case ErrorNames.FAILED_TO_OBTAIN_MEDIA_DEVICES:
                                 $scope.vonageMicrophone = 'failed';
                                 $scope.vonageCamera = 'failed';
                                 break;
                             case ErrorNames.NO_AUDIO_CAPTURE_DEVICES:
                                 $scope.vonageMicrophone = 'failed';
                                 break;
                             case ErrorNames.NO_VIDEO_CAPTURE_DEVICES:
                                 $scope.vonageCamera = 'failed';
                                 break;
                             case ErrorNames.CONNECT_TO_SESSION_NETWORK_ERROR:
                             case ErrorNames.API_CONNECTIVITY_ERROR:
                             case ErrorNames.CONNECTIVITY_ERROR:
                             case ErrorNames.CONNECT_TO_SESSION_ERROR:
                             case ErrorNames.CONNECT_TO_SESSION_ID_ERROR:
                             case ErrorNames.CONNECT_TO_SESSION_TOKEN_ERROR:
                             case ErrorNames.FAILED_MESSAGING_SERVER_TEST:
                             case ErrorNames.INCOMPLETE_SESSON_CREDENTIALS:
                             case ErrorNames.INIT_PUBLISHER_ERROR:
                             case ErrorNames.INVALID_ON_UPDATE_CALLBACK:
                             case ErrorNames.LOGGING_SERVER_CONNECTION_ERROR:
                             case ErrorNames.MISSING_OPENTOK_INSTANCE:
                             case ErrorNames.MISSING_SESSON_CREDENTIALS:
                             case ErrorNames.MISSING_SUBSCRIBER_ERROR:
                             case ErrorNames.NETWORK_TEST_ERROR:
                             case ErrorNames.PUBLISH_TO_SESSION_ERROR:
                             case ErrorNames.PUBLISH_TO_SESSION_NETWORK_ERROR:
                             case ErrorNames.PUBLISH_TO_SESSION_NOT_CONNECTED:
                             case ErrorNames.PUBLISH_TO_SESSION_PERMISSION_OR_TIMEOUT_ERROR:
                             case ErrorNames.QUALITY_TEST_ERROR:
                             case ErrorNames.SUBSCRIBER_GET_STATS_ERROR:
                             case ErrorNames.SUBSCRIBE_TO_SESSION_ERROR:
                                 $scope.vonageConnection = 'failed';
                                 break;
                             default:
                                 $scope.vonageTestStatus = 'failed';
                         }
                     });
                     $scope.vonageTestStatus = 'failed';
                 } else {
                    !$scope.isIOS && startVolumeLevelMeter();
                 }
                 dataService.removeSessionData('testConnectivityStarted');
                 otNetworkTest.testQuality(function updateCallback(stats) {
                    $log.info('Vonage System Test status for vonageSessionId {0} and interviewId {1} - intermediate testQuality stats {2}'.format(OTSessionData.vonageSessionId,$scope.interviewId,convertJSONToString(stats)));
                 }).then(function (results) {
                     var publisherSettings = {};
                     if (results.video.reason) {
                         publisherSettings.videoSource = null;
                         $scope.vonageConnection = 'failed';
                         $log.info('Vonage System Test status for vonageSessionId {0} and interviewId {1} - Video not supported: {2}'.format(OTSessionData.vonageSessionId,$scope.interviewId,results.video.reason));
                     } else {
                         publisherSettings.frameRate = results.video.recommendedFrameRate;
                         publisherSettings.resolution = results.video.recommendedResolution;
                     }
                     if (!results.audio.supported) {
                         $scope.vonageMicrophone = 'failed';
                         $log.info('Vonage System Test status for vonageSessionId {0} and interviewId {1} - Audio not supported: {2}'.format(OTSessionData.vonageSessionId,$scope.interviewId,results.audio.reason));
                         publisherSettings.audioSource = null;
                     }
                     validateSystemCheckStatus();
                     dataService.setSystemTestStatus('completed');
                 }).catch(function (error) {
                     // added the condition to check for a specific error coming for mobile device
                     // Have raised a ticket with vonage, The error also exist on tokbox demo site (for mobile device).
                     // Will update the code once we get a solution from vonage.
                     if($scope.isMobileDevice && error.message.includes('another application')){
                         // Added the condition for mobile device, the testQuality was failing due to error - Audio/video device unavailable or used by another application 
                         $log.info('Vonage System Test status for vonageSessionId {0} and interviewId {1} - Audio/video device unavailable or is used by another application: {2}'.format(OTSessionData.vonageSessionId,$scope.interviewId,convertJSONToString(error.message)));
                     } else{
                         $scope.vonageTestStatus = 'failed';
                         validateSystemCheckStatus();
                         dataService.setSystemTestStatus('failed');
                         $log.error('Vonage System Test status for vonageSessionId {0} and interviewId {1} - OpenTok quality test error: {2}'.format(OTSessionData.vonageSessionId,$scope.interviewId,convertJSONToString(error)));
                     }
                 });
             }).catch(function (error) {
                 $scope.vonageTestStatus = 'failed';
                 validateSystemCheckStatus();
                 dataService.setSystemTestStatus('failed');
                 $log.error('Vonage System Test status for vonageSessionId {0} and interviewId {1} - OpenTok connection test error: {2}'.format(OTSessionData.vonageSessionId,$scope.interviewId,convertJSONToString(error)));
             });
        });
    };


    //Method to create Vonage session for first question or question being taken as first
    //after interview has been stopped from between
     $scope.createVonageSession = function() {
        if(angular.isUndefined($scope.session) || $scope.session.currentState === 'disconnected') {
            $scope.vonageSessionLoading = true;
            videoService.getVonageSessionId({},function(result) {
                if (angular.isDefined(result) && angular.isDefined(result.vonageSessionId) && angular.isDefined(result.vonageSessionToken)) {
                    $scope.initAndConnectSession(window.atob(result.encVonageKey), result.vonageSessionToken, result.vonageSessionId);
                    dataService.setSessionData('vonageProjectKey', result.encVonageKey);
                    dataService.setSessionData('vonageToken', result.vonageSessionToken);
                    $scope.vonageSessionId = result.vonageSessionId;
                }
            return null;
         });
        } else {
            $scope.getQuestion();
        }
     };

     $scope.publishingVonageStreams = function(){
        //Checking capability to publish for session
             if ($scope.session.capabilities.publish === 1) {
             //publishing the session
             $scope.session.publish($rootScope.vonagePublisher, function(error) {
                   if (error) {
                     $log.error('Vonage publishingVonageStreams status for vonageSessionId {0}, interviewId {1} - Error in publishing the stream {2}, QuestionId in progress is: {3}'.format($scope.session.id, $scope.interviewId, JSON.stringify(error), $scope.question.vid));
                   } else {
                     $scope.vonageSessionLoading = false;
                     $log.info('Vonage publishingVonageStreams status for vonageSessionId {0}, interviewId {1} - Publishing a stream, QuestionId in progress is: {2}'.format($scope.session.id, $scope.interviewId, $scope.question.vid));
                   }
             })
             .on('streamDestroyed', function(event) {
                //Once streaming is stopped, by default publisher gets removed from HTML DOM, event.preventDefault() will prevent this behaviour.
                 event.preventDefault();
                 if(!event.stream.destroyed) {
                 //If stream is not destroyed, destory it because we are moving to new question now.
                        event.stream.destroy();
                        $log.info('Vonage streamDestroyed status for interviewId {0} - archiveId {1}, questionId {2}, streamId {3} - Publisher state in streamDestroyed is: {4}'.format($scope.interviewId, $scope.archiveId, $scope.question.vid, event.stream.id, $rootScope.vonagePublisher._.getState().current));
                        if($rootScope.vonagePublisher._.getState().current!=='Publishing'){
                            $scope.submitAnswerForVonage();
                        }
                    }
             })
             .on('streamCreated', function(event) {
                $log.info('Vonage streamCreated status for interviewId {0} - questionId {1} - streamId {2}, resolution - {3}'.format($scope.interviewId, $scope.question.vid, event.stream.id, event.stream.videoDimensions.width+'x'+event.stream.videoDimensions.height));
             });
         }
     };

    $scope.initAndConnectSession = function(projKey,token,session) {
        $scope.session = window.OT.initSession(projKey,session);
        $scope.session.connect(token, function(error) {
            if (error) {
              $log.error('Vonage initAndConnectSession status for vonageSessionId {0} interviewId {1} - Error connecting: {2}'.format($scope.session.sessionId, $scope.interviewId, JSON.stringify(error)));
            } else {
              $log.info('Vonage initAndConnectSession status for vonageSessionId {0} interviewId {1} - Connected to the session'.format($scope.session.sessionId, $scope.interviewId));
              $scope.getQuestion();
              $scope.publishingVonageStreams();
            }
          })
        .on('sessionDisconnected', function(event) {
            $log.info('Vonage initAndConnectSession status for vonageSessionId {0} interviewId {1} - Session disconnected: {2}'.format($scope.session.sessionId, $scope.interviewId, event.reason));
        });
    };

    //Method to start archiving
     $scope.startArchive = function() {
     $scope.beginloading=true;
     videoService.startVonageArchive({
                 'formResponseId':formResponseIdService.getId(),
                 'sessionId':$scope.vonageSessionId,
                 'name':$scope.question.vid
         },function(result) {
                 if(angular.isDefined(result) && angular.isDefined(result.vonageArchive)) {
                     $scope.archiveId = result.vonageArchive.id;
                     $scope.beginloading=false;
                     $scope.videoStatus='recording';
                     $log.info('Vonage startVonageArchive status for vonageSessionId {0} interviewId {1} - Result is: {2}'.format($scope.vonageSessionId, $scope.interviewId, JSON.stringify(result)));
                 }
             }, function(error) {
                 $log.error('Vonage startVonageArchive status for vonageSessionId {0} interviewId {1} -  archiveId {2} - Error in start archiving: {3}'.format($scope.vonageSessionId, $scope.interviewId, $scope.archiveId, convertJSONToString(error)));
        });
    };

    $scope.submitAnswerForVonage = function() {
        //If all the questions are completed, move to confirmation page.
        //1. Disconnect session.
        //2. Destroy publisher
        if($scope.question.sequence === $scope.summary.screeningQuestions) {
            submitAnswer(0);
            $scope.session.disconnect();
            $rootScope.vonagePublisher.destroy();
            $scope.showOnUnloadMessage = false;
            if($scope.interviewType === 'recordInterview') {
                $window.location = $jobviteUrls.video + '/video/jobseeker/confirmationPage.html?id=' + $scope.interviewId;
            } else {
                $location.path('/Playback/' + $scope.interviewType + '/' + $scope.interviewId);
            }
        } else {
            //When any answer is completed.
            submitAnswer(0);
        }
    }

    //Method to stop archiving
     $scope.stopArchiving = function() {
       $scope.stoploading=true;
       videoService.stopVonageArchive({
            'formResponseId':formResponseIdService.getId(),
            'archiveId':$scope.archiveId
        }, function(result) {
               if($scope.videoStatus=='recording'){
                    $scope.videoStatus='done';
               }
               $scope.stoploading=false;
               $scope.submitAnswerForVonage();
               $log.info('Vonage stopArchiving status for interviewId {0} - Publisher state in stopArchiving is: {1}'.format($scope.interviewId,$rootScope.vonagePublisher._.getState().current));
               $log.info('Vonage stopArchiving status for interviewId {0} - Archiving Stopped: {1}'.format($scope.interviewId, $scope.archiveId));
               $scope.archiveId = null;
           }, function(error) {
               $log.error('Vonage stopArchiving status for interviewId {0} - Error in stop archiving: {1}, {2}'.format($scope.interviewId, $scope.archiveId, convertJSONToString(error)));

       });
     };



    $scope.systemTest = dataService.getSystemTest();
    // This string will be sent as a log to the backend on page refreshes, for tracking what the user did.
    $scope.LogMessageString = '';

    if (dataService.getSystemTest() === false && $routeParams.state === 'Setup' && angular.isDefined($routeParams.state)) {
        dataService.setSystemTest(true);
    }

    $scope.systemTestStarted = false;

    // interviewId
    $rootScope.interviewId = $routeParams.interviewId;

    if($scope.interviewType === 'practiceInterview') {
        if (angular.isDefined($routeParams.actualId) && $routeParams.actualId !== null) {
            dataService.setActualId($routeParams.actualId);
        } else {
            if(dataService.getSessionData('isRetakePracticeInterview')){     
                $rootScope.$broadcast('initPublisher',true);
                $scope.videoPreviewLoader = false;
                dataService.removeSessionData('isRetakePracticeInterview');
            };
            var actualId = dataService.getSessionData($routeParams.interviewId+'-actualId');
            dataService.setActualId(actualId);
        }
    }

    formResponseIdService.setId($scope.interviewId);

    // after the answer is submitted call this function so that the scope prepares itself for the next question.
    var reinitializeVideoAnswer = function() {
        $scope.question = null;
        $scope.videoStatus = null; // recording, done, uploading.
    };
    reinitializeVideoAnswer();



    // Add custom properties to results;
    var massageResult = function(result) {
        // 'timeToAnswer' is returned in seconds.
        var _result = result.bean;
        _result.timeToAnswerMills = result.bean.timeToAnswer * 1000;
        _result.timeToAnswerMinutes = parseInt(result.bean.timeToAnswer / 60, 10);
        if (_result.timeToAnswerMinutes < 10) {
            _result.timeToAnswerMinutes = '0' + _result.timeToAnswerMinutes;
        }
        _result.timeToAnswerSeconds = result.bean.timeToAnswer % 60;
        if (_result.timeToAnswerSeconds < 10) {
            _result.timeToAnswerSeconds = '0' + _result.timeToAnswerSeconds;
        }
        _result.timeToPrepareMills = result.bean.timeToPrepare * 1000;
        _result.timeToPrepareMinutes = parseInt(result.bean.timeToPrepare / 60, 10);
        if (_result.timeToPrepareMinutes < 10) {
            _result.timeToPrepareMinutes = '0' + _result.timeToPrepareMinutes;
        }
        _result.timeToPrepareSeconds = result.bean.timeToPrepare % 60;
        if (_result.timeToPrepareSeconds < 10) {
            _result.timeToPrepareSeconds = '0' + _result.timeToPrepareSeconds;
        }
        _result.vid = result.vid;
        return _result;
    };

    // Get the details about the question to appear on the next screen.
    $scope.getQuestionDetails = function() {
        $scope.showOnUnloadMessage = true;
        var sequence=null;
        if($scope.question!==null) {
            sequence=$scope.question.sequence;
        }
        reinitializeVideoAnswer();
         videoService.getQuestionDetails({
               'sequence':sequence
         }, function(result) {
            if (angular.isDefined(result)) {
                if (angular.isDefined(result.interview_complete) && result.interview_complete === true) {
                    // interview is already done. Move to the result summary page.
                    // $location.path('/Review/summary/'+$scope.interviewId);
                    $window.location = $jobviteUrls.video + '/video/jobseeker/confirmationPage.html?id=' + $scope.interviewId;
                    return;
                }

                $scope.question = massageResult(result);
                $scope.questionCopy = angular.copy($scope.question);
                $scope.LogMessageString = result.vid + '__'+$scope.interviewType;
            }
            if ($scope.systemTest) {
                $scope.initSystemTest();
                $scope.videoStatus = 'recordSystemTest';

            }
        });
    };


    $scope.initSystemTest = function() {
        $scope.showControls = false;
        // Commenting the below line as it converts the interview type based on the system test
        // $scope.interviewType = 'practiceInterview';
        
        // Append some text after the interview, so that it does not get mixed with actual/practice interviews
        $scope.question.vid = $scope.question.vid + 'sT';
        $scope.question.timeToAnswer = 30;
        $scope.question.timeToAnswerMills = 30 * 1000;
        $scope.question.showStopRecording = false;
    };

    // For the first time when the page loads, we don't need to ask the user to get the question, trigger it by default.
    $scope.getQuestionDetails();

    $scope.vonageSessionAndGetQuestion = function() {
        $scope.createVonageSession();
    };

    // Get the actual question.
    $scope.getQuestion = function() {
        //If vonageRecording is on, we have conditions for first and
        //other questions
        var formResponseId = formResponseIdService.getId();
        $scope.isIncompleteVideo = false;
        var videoId = $scope.question.vid;
        var sequence=$scope.question.sequence;
        videoService.getQuestion({
            'id':formResponseId,
            'vid':videoId,
            'sequence':sequence
        }, function(result) {
            $scope.LogMessageString += '__'+result.title;
            $scope.question.Q = result.title;
        });
    };

    // Submit the answer for the question. Callback from the red5 javascript.
    var submitAnswer = function(duration) {
        var videoId = $scope.question.vid;
        var sequence = $scope.question.sequence;
        videoService.sendAnswer({
            'sequence': sequence,
            'vid': videoId,
            'duration': Math.ceil(duration)
        }, function(result) {
            if ($scope.summary.screeningQuestions === $scope.question.sequence) {
                $scope.showOnUnloadMessage = false;
                if ($scope.interviewType === 'recordInterview') {
                    $window.location = $jobviteUrls.video + '/video/jobseeker/confirmationPage.html?id=' + $scope.interviewId;
                    return;
                } else {
                    $location.path('/Playback/' + $scope.interviewType + '/' + $scope.interviewId);
                }
            } else {
                $scope.getQuestionDetails();
            }
        });
    };

    $scope.totalQArray = function(number) {
            return new Array(number);

    };

    $scope.isAnswered = function(i) {
        if (i < $scope.question.sequence) {
            return true;
        } else {
            return false;
        }
    };

    $scope.isCurrentAnswer = function(i) {
        if (i == $scope.question.sequence) {
            return true;
        } else {
            return false;
        }
    };

    $scope.unaswered = function(i) {
        if (i > $scope.question.sequence) {
            return true;
        } else {
            return false;
        }
    };


    $scope.isFirstQuestion = function() {
        if ($scope.question) {
            if ($scope.question.sequence === 1 && $scope.question.Q === undefined) {
                return true;
            } else {
                return false;
            }
        }
    };

    $scope.isNotFirstQuestion = function() {
        if ($scope.question && $scope.question.sequence !== 1 && $scope.question.Q === undefined) {
            return true;
        } else {
            return false;
        }
    };

    $scope.$on('DONE_UPLOADING', function(newValue, val) {
        $timeout.cancel($scope.uploadFailurePromise);
        if ($scope.videoStatus !== 'done') {
            $scope.videoStatus = 'done';
            if (!$scope.systemTest) {
                submitAnswer(val);
            } else {
                $scope.videoStatus = 'playbackSystemTest';
                $scope.systemTestVideoUrl = [];
                // Depending on whether wowza or red5 is enabled, create the URL accordingly. Once we decide on one solution
                // this code and property from database would go away.
                if (wowzaEnabled) {
                    $scope.systemTestVideoUrl[0] = $window.location.protocol + '//' + $jobviteUrls.rtmpUrl + '/' + $scope.question.vid + '.flv';
                } else {
                    $scope.systemTestVideoUrl[0] = $window.location.protocol + '//' + $jobviteUrls.rtmpUrl + '/' + 'practice-' + $rootScope.interviewId + '/' + $scope.question.vid + '.flv';
                }
                $scope.recordedOnce = true;
                $scope.systemTestStarted = false;
            }
        }
    });
    
    /**
     * The new flash has issues with the replay. The solution would be to rerender the video player with the same flash file.
     */
    $scope.reRenderVideo =  function(){
        $scope.systemTestVideoUrl = [];
        $scope.systemTestVideoUrl[0] = $window.location.protocol + '//' + $jobviteUrls.rtmpUrl + '/' + $scope.question.vid + '.flv';
    };
        
    $scope.handleRecordError = function() {
        if ($scope.videoStatus !== 'done') {
            $scope.videoStatus = 'done';
            // Since it was an error in recording, send the duration of the video to be -1.
            submitAnswer(-1);
            $route.reload();
        }
    };
    
    $scope.recordTimeout = function() {
        if(angular.isDefined($scope.question)){
            $log.info('Vonage recordTimeout status for interviewId {0} - Timeout Error for VideoId: {1}'.format($scope.interviewId, $scope.question.vid));
        }
        $scope.handleRecordError();
    };

    $scope.$on('RECORD_ERROR', function(newValue, val) {
        if(angular.isDefined($scope.question)){
            $log.info('Vonage  RECORD_ERROR status for  interviewId {0} - Record Error for VideoId: {1}'.format($scope.interviewId, $scope.question.vid));
        }
        $timeout.cancel($scope.uploadFailurePromise);
        $scope.handleRecordError();
    });
    
    $scope.startSystemTestTimer = function(){
        var maxCount = 5;
        $scope.question.timeToAnswerMills = 5 * 1000;  // 5 second countdown

        function repeater(){
            if(maxCount < 0){
                $scope.videoStatus='uploading';
                $scope.systemTestStarted=false;
                $scope.recordedOnce=true;
            }else{
                maxCount--;
                $timeout(repeater, 1000);
            }
        }
        repeater();
    }

    $scope.$watch('videoStatus', function(newVal, oldVal) {
        $log.info('Vonage videoStatus for interviewId {0} - videoStatus -{0} {2}'.format($scope.interviewId,newVal, oldVal));
        if (newVal === 'recording') {
            if ($scope.systemTest) {
                $scope.question.showStopRecording = true;
            } else {
                $timeout(function() {
                    $scope.question.showStopRecording = true;
                }, 5000);
            }
        }
        else if (newVal === 'uploading') {
            // set a 10 second timeout, which would indicate that the upload didn't complete successfully
            $scope.uploadFailurePromise = $timeout(function() {
            // if the upload fails, there's really no corrective action to take, so treat as an error and allow the user to proceed to the next question
                $scope.recordTimeout();
            }, 10000);
        }
    });



    // event fired by the timer directive.
    $scope.$on('TIMER_COMPLETE', function() {
        if ($scope.videoStatus === 'prepareTime') {

            if($scope.vonageRecording) {

                $scope.startArchive();
            }
            $scope.videoStatus = 'recording';
            // show the stop recording sign after at least 10 seconds of recording.
        } else if ($scope.videoStatus === 'recording') {
            //if Vonage is enabled, we dont move to uploading.
            //Even if vonage is enabled, for time being, for system test, this will be moved to
            //uploading only. Once system test also is moved to Vonage, this is to be changed.
            if(angular.isDefined($scope.vonageRecording) && $scope.vonageRecording && !$scope.systemTest) {
                $scope.videoStatus = 'done';
                $scope.stopArchiving();
            } else {
                $scope.videoStatus = 'uploading';
            }

        } else {
            $scope.videoStatus = 'done';
            // the backend still wants the video id even if no video is recorded.
        }
    });

    $scope.$on('CAMERA_INITIALIZED', function() {
        $scope.cameraInit = true;
        // Delaying the variable by 500 milliseconds because camera takes sometime before it shows up.
        // Will prevent users from clicking on begin interview while the camera is not ready.
        $timeout(function() {
            if ($scope.flashStatus === 'failed' || $scope.adobeStatus === 'failed') {
                $scope.showControls = false;
            } else {
                // once the camera is initialized ask for the media permissions.
                detectUserMedia();
                $scope.showControls = true;
            }
        }, 500);
    });

    $scope.$on('FLASH_INSTALLED', function() {
        $scope.flashStatus = 'passed';
        if (browserDetails.getFlashVersion().split(',').shift() >= 12) {
            $scope.adobeStatus = 'passed';
        } else {
            $scope.adobeStatus = 'failed';
        }
    });

    $scope.$on('FLASH_NOT_INSTALLED', function() {
        $scope.flashStatus = 'failed';
    });

    $scope.$on('CAMERA_PRESENT', function() {
        $scope.cameraStatus = 'passed';
    });

    $scope.$on('CAMERA_MUTED', function() {
        $scope.cameraStatus = 'muted';
    });

    $scope.$on('CAMERA_NOT_PRESENT', function() {
        $scope.cameraStatus = 'failed';
    });

    $scope.$on('MIC_PRESENT', function() {
        $scope.micStatus = 'passed';
    });

    $scope.$on('MIC_NOT_PRESENT', function() {
        $scope.micStatus = 'failed';
    });

    $scope.$watch('[micStatus,cameraStatus,flashStatus,adobeStatus,showControls,browserCameraAccess]', function(val) {
        $scope.testStatus = 'progress';
        if ($scope.micStatus === 'passed' && $scope.cameraStatus === 'passed' && $scope.flashStatus === 'passed' && $scope.adobeStatus === 'passed' && $scope.showControls === true) {
            if($scope.userMediaSupported){
                if($scope.browserCameraAccess === 'passed'){
                    $scope.testStatus = 'passed';
                }
            }else{
                $scope.testStatus = 'passed';
            }

        } else if ($scope.micStatus === 'failed' || $scope.cameraStatus === 'failed' || $scope.flashStatus === 'failed' || $scope.adobeStatus === 'failed') {
            if($scope.userMediaSupported){
                if($scope.browserCameraAccess === 'failed'){
                    $scope.testStatus = 'failed';
                }
            }else{
                $scope.testStatus = 'failed';
            }
        }
    }, true);



    $scope.$watch('summary', function(newVal, oldVal) {
        // Video has already expired, so redirect the user to the expired page.
        if (angular.isDefined(newVal) && (newVal.status === 'EXPIRED' || newVal.status === 'COMPLETE')) {
            $scope.showOnUnloadMessage = false;
            $location.path('/UnreachableInterview/' + newVal.status.toLowerCase() + '/' + $rootScope.interviewId);
        }
    });

    $scope.startSetup = function() {
        dataService.removeSessionData('completedSystemTest');
        $location.path('/Interview/' + $routeParams.type + '/' + $scope.interviewId);
    };

    $scope.getInterviewType = function() {
        return $routeParams.type;
    };

    $scope.systemTestRetake = function() {
        $scope.videoStatus = '';
        $scope.initSystemTest();
        $scope.systemTestStarted = false;
        $scope.videoStatus = null;
        $scope.testStatus = null;
        $scope.systemTest = true;
        $scope.hideTestButton = false;
        $route.reload();
        return;
    };

    /**
     * @method slideNext
     * @description Switches between the slides based on the flag being set to true or false
     */
    $scope.slideNext = function() {
        $scope.instructionStep1 ? ($scope.instructionStep1 = false, $scope.instructionStep2 = true)
         : ($scope.instructionStep2 = false, $scope.instructionStep3 = true);
    };

    /**
     * @method slideBack
     * @description Switches between the slides based on the flag being set to true or false
     */
    $scope.slideBack = function() {
        $scope.instructionStep2 ? ($scope.instructionStep2 = false, $scope.instructionStep1 = true)
         : ($scope.instructionStep3 = false, $scope.instructionStep2 = true);
    };


    $scope.hideStep1 = function(){
        return $scope.flashStatus === 'passed' && $scope.adobeStatus === 'passed' && $scope.cameraStatus === 'passed' && $scope.micStatus === 'passed' && $scope.userMediaSupported!=null && (($scope.userMediaSupported && $scope.browserCameraAccess === 'passed') || (!$scope.userMediaSupported && $scope.browserCameraAccess==null));
    };
    
    $scope.checkStep2Condition = function() {
        return ($scope.userMediaSupported!=null &&
            $scope.systemTest &&
            $scope.flashStatus === 'passed' &&
            $scope.adobeStatus === 'passed' &&
            $scope.cameraStatus === 'passed' &&
            $scope.micStatus === 'passed' &&
            (($scope.userMediaSupported && $scope.browserCameraAccess === 'passed') || (!$scope.userMediaSupported && !$scope.browserCameraAccess)) &&
            ($scope.videoStatus === 'recordSystemTest' || $scope.videoStatus === 'recording'));
    };
    
    $scope.showStep2Overlay = $scope.checkStep2Condition();
    
    $scope.hideSystemTestOverlay = function(hide) {
        if(!!hide) {
            $scope.showStep2Overlay = false;
        } else {
            $scope.showStep2Overlay = $scope.checkStep2Condition();
        }
    };
    
    $scope.showStep2 = function(){
        var show = $scope.checkStep2Condition();
        return show;
    };

    
    if (window.JV.PAGE_TYPE === 'JOBSEEKER_VIDEO_SETUP') {
        if (dataService.getSessionData('completedSystemTest')) {
            // if the user has already successfully completed the system test
            // during this browser session, no need to go through the system test again
            $scope.moveToInterview();

            return;
        }
    }
    var convertJSONToString = function(resultObj) {
           var convertToString =  '';
           try{
               convertToString = JSON.stringify(resultObj);
               }
           catch(error){
                convertToString = 'Not a JSON Object';
           }
           return convertToString;
        };

}]);

